import type { ActionChoiceDto, ActionPlanItem, ActionToAddDto } from '@/infra/api/generated/model'

export const toActionToAdd = ({ id, isCustom }: ActionChoiceDto): ActionToAddDto => ({
  id,
  isCustom,
})

export const isActionSelected = (selection: ActionToAddDto[], actionId: string): boolean =>
  selection.some((action) => action.id === actionId)

export const removeAction = (selection: ActionToAddDto[], actionId: string): ActionToAddDto[] =>
  selection.filter((action) => action.id !== actionId)

export const toggleAction = (
  selection: ActionToAddDto[],
  action: ActionToAddDto
): ActionToAddDto[] =>
  isActionSelected(selection, action.id)
    ? removeAction(selection, action.id)
    : [...selection, action]

export const findPreselectedActions = (
  selectedActions: ActionPlanItem[],
  choices: ActionChoiceDto[]
): ActionToAddDto[] => {
  const selectedIds = new Set(selectedActions.map((action) => action.actionId))
  return choices.filter((choice) => selectedIds.has(choice.id)).map(toActionToAdd)
}
